import React, { useEffect, useState } from "react";

const ToggleSwitch = ({ onToggle, isUnassigned = true, label1, label2 }) => {
  const [isToggled, setIsToggled] = useState(false);

  const handleToggle = () => {
    setIsToggled((prev) => {
      const newState = !prev;
      onToggle(newState);
      return newState;
    });
  };

  useEffect(() => {
    if (isToggled && !isUnassigned) {
      setIsToggled(false);
      onToggle(false);
    }
  }, [isUnassigned]);

  return (
    <div className="flex items-center">
      <div
        onClick={handleToggle}
        className={`relative inline-block w-12 h-6 rounded-full cursor-pointer ${isToggled ? "bg-orange-500" : "bg-gray-300 dark:bg-slate-700"
          }`}
      >
        <div
          className={`absolute top-0 left-0 w-6 h-6 bg-white dark:bg-slate-600 rounded-full transition-all ${isToggled ? "translate-x-6" : "translate-x-0"
            }`}
        ></div>
      </div>
      <span
        className={`ml-2 text-sm ${isToggled ? "text-orange-500" : "text-gray-400 dark:text-slate-500"
          }`}
      >
        {isToggled ? label1 : label2}
      </span>
    </div>
  );
};

export default ToggleSwitch;
